import { useSyncExternalStore } from "react";

/**
 * Подписка на медиазапрос (AUFB-67).
 *
 * useSyncExternalStore — правильный примитив для внешнего источника: React
 * читает значение синхронно при первом рендере, поэтому нет кадра, в котором
 * мобильный шелл мигает десктопной раскладкой.
 *
 * Область применения намеренно узкая: JS решает, КАКОЙ компонент рендерить
 * (сайдбар или таб-бар), а как он выглядит — решает CSS. Всё, что можно
 * выразить медиазапросом в .css, туда и должно идти.
 */

const cache = new Map();

function getMql(query) {
  if (typeof window === "undefined" || !window.matchMedia) return null;
  if (!cache.has(query)) cache.set(query, window.matchMedia(query));
  return cache.get(query);
}

export function useMediaQuery(query) {
  const subscribe = (onChange) => {
    const mql = getMql(query);
    if (!mql) return () => {};
    // addEventListener есть не во всех старых WebView; addListener — фолбэк.
    if (mql.addEventListener) {
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  };

  const getSnapshot = () => {
    const mql = getMql(query);
    return mql ? mql.matches : false;
  };

  // На сервере (и в тестах без jsdom) считаем, что это не мобильный:
  // десктопная раскладка — основная.
  const getServerSnapshot = () => false;

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

/** Брейкпоинты Soft Slate. Держать синхронно с *.css. */
export const BREAKPOINTS = Object.freeze({
  mobile: "(max-width: 720px)",
  compact: "(max-width: 1024px)",
});

export function useIsMobile() {
  return useMediaQuery(BREAKPOINTS.mobile);
}

export default useMediaQuery;
